module.exports = __webpack_public_path__ + "static/LOGO CE_Vertical_EN_NEG_PANTONE_LR-038da857bfa78cfe05cb4a4e9518b7e3.png";